module.exports = __webpack_public_path__ + "assets/img/logo_long_stage.fbd980f1.svg";